import "./aboutMe.css";
import { ownerDescription } from "../../pages/Home/Home.jsx";

export const AboutMe = () => {
  return (
    <div
      className="aboutMeWrapper"
      id="kdojsem"
      data-aos="fade-up"
      data-aos-duration="2000"
    >
      {" "}
      <h1>KDO JSEM</h1>
      <hr className="headerUnderline" />
      <div className="aboutMe">
        <div className="left">
          <img src={require("../../media/samPortrait.webp")} alt="" />
        </div>
        <div className="right aboutMeText">
          <h3>Sam</h3>
          <p>{ownerDescription}</p>
          <p>
            Můj barber shop je místem, kde se tradice spojuje s moderními
            trendy, a kde vkládám své srdce a duši do každého zákazníka,
            vytvářejíc s nimi nejen úžasný vzhled, ale i dlouhotrvající vztahy.
          </p>
          <p>
            Jsem přesvědčen, že klíčem k úspěchu je komunikace. Proto vždy dbám
            na to, aby si každý klient odnesl nejen skvělý vzhled, ale i pocit,
            že byl vyslyšen. Věřím, že právě toto dělá z každé návštěvy u mě
            něco speciálního.
          </p>
          <p>I speak fluently in English and Arabic.</p>
        </div>
      </div>
    </div>
  );
};
